import _ from 'lodash';
import storeCreateSuccessModal from './storeCreateSuccess.html';

class StoreAddController {
  /* @ngInject */
  constructor($log, $q, $scope, $location, $rootScope, $filter, NewBackendService, endPoints, StoreService, StorageService, MerchantConfigurationService, ImageUtilsService, FoundationApi, $element, MerchantDetailService, NewTokenService, CategoriesService, ModalFactory, $timeout) {
    const that = this;
    this.editMode = false;
    this.duplicateMode = false;
    this.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
    this.myCroppedImage = '';
    this.myCroppedAvatar = '';
    this.errorImage = '';
    this.isLoadingImage = false;
    this.manualAddress = false;
    this.userProfile = {};
    this.contacts = {};
    this.profileObj = {
      avatarImage: '',
      coverImage: '',
      isCrop: false,
      position: false
    };
    this.imageType = undefined;

    this.showModal = (title, subtitle) => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: storeCreateSuccessModal,
        class: 'default',
        contentScope: {
          okFunc: closeModal,
          editMode: that.editMode,
          title: title,
          subtitle: subtitle
        }
      });

      modal.activate();
    };


    this.addressModal = false;

    this.toggleManualAddress = () => {
      this.manualAddress = !this.manualAddress;
      this.resetAddressFields();
    };

    this.resetAddressFields = () => {
      this.contacts.address.city = '';
      this.contacts.address.zip = '';
      this.contacts.address.province = '';
      this.contacts.address.street = '';
      this.contacts.address.nazione = '';
      this.contacts.address.nr = '';
      this.contacts.address.latitudine = '';
      this.contacts.address.longitudine = '';
      this.contacts.fullAddress = '';
    }

    this.openAddressModal = () => {
      that.addressModal = true;
    };

    this.closeAddressModal = () => {
      that.addressModal = false;
    };

    this.contactsBackup = undefined;

    this.loading = {
      contacts: false,
      details: false
    };

    this.saveStore = () => {
      var store = {
        name: this.contacts.name,
        visible: this.contacts.visible,
        city: this.contacts.address ? this.contacts.address.city : '',
        postalCode: this.contacts.address ? this.contacts.address.zip : '',
        province: this.contacts.address ? this.contacts.address.province : '',
        street: this.contacts.address ? this.contacts.address.street : '',
        country: this.contacts.address ? this.contacts.address.nazione : '',
        streetNumber: this.contacts.address ? this.contacts.address.nr : '',
        latitude: this.contacts.address.latitudine ? parseFloat(this.contacts.address.latitudine) : '',
        longitude: this.contacts.address.longitudine ? parseFloat(this.contacts.address.longitudine) : '',
        avatarImage: this.contacts.imageBase64 ? this.contacts.imageBase64 : this.contacts.image ? this.contacts.image.split('data:image/png;base64,')[1] : '',
        indoorImage: this.contacts.indoorBase64 ? this.contacts.indoorBase64 : this.contacts.indoorImage ? this.contacts.indoorImage.split('data:image/png;base64,')[1] : '',
        outdoorImage: this.contacts.outdoorBase64 ? this.contacts.outdoorBase64 : this.contacts.outdoorImage ? this.contacts.outdoorImage.split('data:image/png;base64,')[1] : '',
        heroImage: this.contacts.heroImageBase64 ? this.contacts.heroImageBase64 : this.contacts.heroImage ? this.contacts.heroImage.split('data:image/png;base64,')[1] : '',
        phoneNumber: this.contacts.phoneNumber,
        email: this.contacts.email,
        supportPhoneNumber: this.contacts.supportPhoneNumber,
        supportEmail: this.contacts.supportEmail,
        web: this.contacts.web,
        customName: this.contacts.customName ? this.contacts.customName : '',
        customValue: this.contacts.customValue ? this.contacts.customValue : '',
        facebook: this.contacts.facebook,
        twitter: this.contacts.twitter,
        instagram: this.contacts.instagram,
        youtube: this.contacts.youtube,
        tiktok: this.contacts.tiktok,
        openingHours: this.contacts.openingHours,
        // message: this.contacts.image,
        description: this.contacts.description,
        categoryIds: this.saveCategories(),
        //defaultImage: this.contacts.defaultImage
      };
      formatSocialUrl();
      var validate = this.validateData(store);
      if (validate == 1) {
        $timeout(this.showModal($filter('translate')('store.address.notvalid'), $filter('translate')('store.address.notvalid.subtitle')));
      } else if (validate == 2) {
        $timeout(this.showModal($filter('translate')('store.insegna.notvalid'), $filter('translate')('store.insegna.notvalid.subtitle')));
      } else {
        StoreService.saveNewStore(store).then(res => {
          $timeout(this.showModal($filter('translate')('store.created.success.modal')), 1000);
          window.location.href = '#/store/register';
        }).catch(() => {
          that.loading.contacts = false;
          $timeout(this.showModal($filter('translate')('store.edited.failed.modal')), 1000);
        });
      }
    };

    this.validateData = (store) => {
      var address = {
        city: store.address ? store.address.city : this.contacts.address.city,
        postalCode: store.address ? store.address.zip : this.contacts.address.zip,
        province:  store.address ? store.address.province : this.contacts.address.province,
        street: store.address ? store.address.street : this.contacts.address.street,
        country: store.address ? store.address.nazione : this.contacts.address.nazione,
        streetNumber: store.address ? store.address.nr : this.contacts.address.nr
      };
      if (address.city == undefined || address.postalCode == undefined || address.province == undefined || address.street == undefined || address.country == undefined || address.streetNumber == undefined
          || address.city == '' || address.postalCode == '' || address.province == '' || address.street == '' || address.country == '' || address.streetNumber == '') {
        return 1;
      } else if (store.name == undefined || store.name == '') {
        return 2;
      } else {
        return 0;
      }

    };

    this.resetModal = () => {
      that.profileObj.isCrop = false;
      that.profileObj.coverImage = '';
      that.profileObj.avatarImage = '';
      document.getElementById('avatar').src = '';
      FoundationApi.closeActiveElements();
    };

    this.resizeImage = () => {
      that.profileObj.isCrop = false;
      if (that.imageType == 'indoor') {
        that.contacts.indoorImage = that.myCroppedCover;
        that.contacts.indoorImageBase64 = undefined;
      } else if (that.imageType == 'outdoor') {
        that.contacts.outdoorImage = that.myCroppedCover;
        that.contacts.outdoorImageBase64 = undefined;
      } else if (that.imageType == 'heroImage') {
        that.contacts.heroImage = that.myCroppedAvatar;
        that.contacts.heroImageBase64 = undefined;
      } else {
        that.contacts.image = that.myCroppedAvatar;
      }

      that.errorImage = '';
    };

    this.uploadImage = () => {
      if (that.myCroppedAvatar === '') {
        return;
      }
      that.contacts.image = that.myCroppedAvatar;
      that.contacts.imageBase64 = undefined;
      FoundationApi.closeActiveElements();
      that.profileObj.avatarImage = '';
      that.myCroppedImage = '';
      // document.getElementById('avatar').src = '';
    };

    const loadCategories = idShop => {
      this.loading.categories = true;
      CategoriesService.getMerchantCategories(idShop).then(categories => {
        const cats = categories || [];
        let catlist = [];
        _.map(cats.categories, macro => {
          catlist = catlist.concat(_.map(macro.subcategories, sub => {
            return { name: sub.name, id: sub.id, link: sub._links.self.href };
          }));
        });
        this.selectedCategoryList = catlist;
        loadPreselection(this.categoryList);

      }).finally(() => {
        this.loading.categories = false;
      });
    };

    const loadPreselection = obj => {
      const arrayPreselection = this.selectedCategoryList;
      _.each(arrayPreselection, pre => {
        const i = _.findIndex(obj, { name: pre.name });
        if (i > -1) {
          obj[i].checked = true;
        }
      });
    };

    const loadAllCategories = () => {
      this.loading.allCategories = true;
      CategoriesService.getAllCategories().then(categories => {
        const cats = categories || [];
        let catlist = [];
        _.map(cats.categories, macro => {
          catlist = catlist.concat(_.map(macro.subcategories, sub => {
            return { name: sub.name, id: sub.id, link: sub._links.self.href };
          }));
        });
        this.categoryList = _.sortBy(catlist, 'name');
        if (this.editMode) loadCategories(that.contacts.id);
        // loadPreselection(this.categoryList);
      }).finally(() => {
        this.loading.allCategories = false;
      });
    };

    this.selectCategory = (obj) => {
      if (obj.checked) obj.checked = false; else {
        if (countCategorySelected() < 4) obj.checked = true;
      }
    };

    const countCategorySelected = () => {
      let count = 0;
      _.forEach(this.categoryList, cat => {
        if (cat.checked) {
          count ++;
        }
      });
      return count;
    };

    this.saveCategories = () => {
      let categoryIds = [];
      _.forEach(this.categoryList, cat => {
        if (cat.checked) categoryIds.push(cat.id);
      });
      return categoryIds;
    };

    const editCategories = () => {
      let urlRequest = '';
      _.forEach(this.categoryList, cat => {
        if (cat.checked) urlRequest = urlRequest + cat.link + '\n';
      });
      if (urlRequest != '') {
        CategoriesService.setMerchantCategories(urlRequest, that.contacts.id).then(() => {
          loadCategories(that.contacts.id);
        }).finally(() => {
          closeModal();
        });
      }
    };

    this.saveAddress = () => {
      this.fieldEmpty = false;
      _.forEach(that.contacts.address, field => {
        if (field === '') this.fieldEmpty = true;
      });
      if (this.fieldEmpty) return;
      that.loading.saveAddress = true;
      MerchantConfigurationService.modifyShop(that.contacts.id, 'I', that.contacts.address.city, that.contacts.address.province, that.contacts.address.nr, that.contacts.address.street, that.contacts.address.zip, true, that.contacts.address.latitudine, that.contacts.address.longitudine).finally(() => {
        that.loading.saveAddress = false;
        this.contactsBackup.address = this.contacts.address;
      });
    };

    const handleFileSelect = (evt) => {
      if (evt.files === null || evt.files == undefined) return;
      const file = evt.files[0];
      if (file.size > 4194304) {
        that.errorImage = 'Dimensione massima di caricamento 4MB';
        return;
      } else if (/gif/.test(file.type)) {
        that.errorImage = 'Estensione consentita PNG - JPG';
        return;
      }
      that.profileObj.isCrop = true;
      const reader = new FileReader();
      reader.onload = (evnt) => {
        $scope.$apply(() => {
          if (evt.id === 'fileCover') {
            that.profileObj.coverImage = evnt.target.result;
          } else {
            that.profileObj.avatarImage = evnt.target.result;
          }
        });
      };
      reader.readAsDataURL(file);
    };

    const formatSocialUrl = () => {
      _.forEach(this.contacts, (element, index) => {
        if (/twitter|facebook|instagram|youtube|tiktok/.test(index)) {
          if (element && element != '' && element.indexOf('https') === -1) {
            this.contacts[index] = `https://${element}`;
          }
        } else if (/web/.test(index)) {
          if (element && element != '' && element.indexOf('http') === -1) {
            this.contacts[index] = `http://${element}`;
          }
        }
      });
    };

    this.saveMerchantContacts = () => {
      if (that.loading.contacts) return;
      formatSocialUrl();
      var validate = this.validateData(this.contacts);
      if (validate == 1) {
        $timeout(this.showModal($filter('translate')('store.address.notvalid'), $filter('translate')('store.address.notvalid.subtitle')));
      } else if (validate == 2) {
        $timeout(this.showModal($filter('translate')('store.insegna.notvalid'), $filter('translate')('store.insegna.notvalid.subtitle')));
      } else {
        that.loading.contacts = true;
        MerchantConfigurationService.setMerchantContacts(this.contacts, that.duplicateMode).then(() => {
          editCategories();
          $timeout(this.showModal($filter('translate')('store.edited.success.modal')), 1000);
          that.loading.contacts = false;
        }).catch(() => {
          that.loading.contacts = false;
          $timeout(this.showModal($filter('translate')('store.edited.failed.modal')), 1000);
        });
      }
    };

    this.resetNewStore = () => {
      window.location.href = '#/store/register';
    };


    const loadStoreForEdit = (store) => {
      that.contacts = {
        id: store.id,
        name: store.name,
        visible: store.visible,
        fullAddress: !that.duplicateMode ? `${store.street} ${store.streetNumber}, ${store.city}, ${store.province} ${store.postalCode}` : '',
        address: !that.duplicateMode ? {
          city : store.city,
          zip : store.postalCode,
          province : store.province,
          street : store.street,
          nazione : store.country,
          nr : store.streetNumber,
          latitudine : store.latitude,
          longitudine : store.longitude,
        } : {},
        image: store._links ? store._links.avatar : '',
        indoorImage: store._links ? store._links.indoor : '',
        outdoorImage: store._links ? store._links.outdoor : '',
        heroImage: store._links ? store._links.hero : '',
        phoneNumber: store.phoneNumber ? store.phoneNumber : '',
        email: store.email ? store.email : '',
        supportPhoneNumber: store.supportPhoneNumber ? store.supportPhoneNumber : '',
        supportEmail: store.supportEmail ? store.supportEmail : '',
        web: store.web ? store.web : '',
        customName: store.customName ? store.customName : '',
        customValue: store.customValue ? store.customValue : '',
        facebook: store.facebook ? store.facebook : '',
        twitter: store.twitter ? store.twitter : '',
        instagram: store.instagram ? store.instagram : '',
        youtube: store.youtube ? store.youtube : '',
        tiktok: store.tiktok ? store.tiktok : '',
        openingHours: store.openingHours ? store.openingHours : '',
        description: store.description ? store.description : '',
        categoryIds: store.categoryIds,
        //defaultImage: store.defaultImage
      };
      if (that.contacts.image && that.contacts.image.href) {
        NewBackendService.invokeWebApiGet(that.contacts.image.href.replace('https://valid.tinaba.tv/', ''), {}, true, 'arraybuffer').then(res => {
          that.contacts.image = ImageUtilsService.byteArrayToUrl(res.data);
          if (that.duplicateMode) {
            that.contacts.imageBase64 = ImageUtilsService.byteArrayToBase64(res.data);
          }
        }, (reason) => {
          $log.error('ProfileRegistryController', 'getAvatar', reason);
        }).finally(() => {
        });
      }
      if (that.contacts.heroImage && that.contacts.heroImage.href) {
        NewBackendService.invokeWebApiGet(that.contacts.heroImage.href.replace('https://valid.tinaba.tv/', ''), {}, true, 'arraybuffer').then(res => {
          that.contacts.heroImage = ImageUtilsService.byteArrayToUrl(res.data);
          if (that.duplicateMode) {
            that.contacts.heroImageBase64 = ImageUtilsService.byteArrayToBase64(res.data);
          }
        }, (reason) => {
          $log.error('ProfileRegistryController', 'getAvatar', reason);
        }).finally(() => {
        });
      }
      if (that.contacts.indoorImage && that.contacts.indoorImage.href) {
        NewBackendService.invokeWebApiGet(that.contacts.indoorImage.href.replace('https://valid.tinaba.tv/', ''), {}, true, 'arraybuffer').then(res => {
          that.contacts.indoorImage = ImageUtilsService.byteArrayToUrl(res.data);
          if (that.duplicateMode) {
            that.contacts.indoorBase64 = ImageUtilsService.byteArrayToBase64(res.data);
          }
        }, (reason) => {
          $log.error('ProfileRegistryController', 'getAvatar', reason);
        }).finally(() => {
        });
      }
      if (that.contacts.outdoorImage && that.contacts.outdoorImage.href) {
        NewBackendService.invokeWebApiGet(that.contacts.outdoorImage.href.replace('https://valid.tinaba.tv/', ''), {}, true, 'arraybuffer').then(res => {
          that.contacts.outdoorImage = ImageUtilsService.byteArrayToUrl(res.data);
          if (that.duplicateMode) {
            that.contacts.outdoorBase64 = ImageUtilsService.byteArrayToBase64(res.data);
          }
        }, (reason) => {
          $log.error('ProfileRegistryController', 'getAvatar', reason);
        }).finally(() => {
        });
      }
    };

    const init = () => {
      const shopId = $location.search().store;

      if (shopId) {
        if ($location.search().edit) {
          that.editMode = true;
        } else {
          that.duplicateMode = true;
        }
        // Try to resolve merchantId using the storage

        let businessId;
        const merchantDeviceData = localStorage.getItem("userContext");
        if (merchantDeviceData) {
          businessId = JSON.parse(merchantDeviceData).business.id
        } else {
          return;
        }

        CategoriesService.getMerchantShop(businessId, shopId).then(response => {
          loadStoreForEdit(response);
          loadAllCategories();
        })
      }


      $element.on('change', (e) => {
        handleFileSelect(e.target);
      });
    };

    that.$onInit = init;


  }
}

export default StoreAddController;



/** WEBPACK FOOTER **
 ** ./client/app/components/store/storeAdd/storeAdd.controller.js
 **/